export enum SearchType {
    PCC = 'pcc',
    COUNTRY = 'country',
    AGENCY_NAME = 'AgencyName',
    SABRE_ID = 'SabreId',
    AGENT_NAME = 'AgentName',
    ROLE_ID = 'RoleId',
    ROLE_NAME = 'RoleName'
}
